import { Option } from './Option';
import { Root } from './Root';
export const Select = { Root, Option };
